var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 23c-.2 0-.3 0-.5-.1-.4-.2-.6-.7-.5-1.2l2.4-7.2H5.6c-.3 0-.6-.1-.8-.4-.2-.2-.3-.5-.2-.8L7.1 1.8c.1-.5.5-.8 1-.8h6.8c.3 0 .6.2.8.4.2.3.2.6.1.9l-1.9 5.5h4.5c.4 0 .7.2.9.6.2.3.1.8-.1 1.1L8.5 22.6c-.2.3-.5.4-.8.4zm-.8-10.5h3.7c.3 0 .6.2.8.4.2.3.2.6.1.9l-1.1 3.3 5.9-7.2h-3.8c-.3 0-.6-.2-.8-.4-.2-.3-.2-.6-.1-.9L13.4 3H8.9l-2 9.5z"
  })));
}

export default SvgIconApi;